import { render, staticRenderFns } from "./reportTab.vue?vue&type=template&id=25114a48&scoped=true&"
import script from "./reportTab.vue?vue&type=script&lang=js&"
export * from "./reportTab.vue?vue&type=script&lang=js&"
import style0 from "./reportTab.vue?vue&type=style&index=0&id=25114a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25114a48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCardTitle,VCol,VRow,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
